import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const StudentInfoCard = ({
  student,
  onAddClick,
  balance,
  writeOffRemaining,
}) => {
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  return (
    <Box className='bg-[#FAFBFF] rounded-lg border border-[#F1F1F1] mb-2'>
      <Box className='p-6'>
        <Typography
          className='font-semibold text-[#1976d2] text-lg inline-block'
          variant='h2'
        >
          Student Details({student?.studentId})
        </Typography>{' '}
        <Status status={student?.status} />
        {writeOffRemaining && (
          <span className='text-red-500'>
            {' '}
            (StudentFee was WrittenOff and marked as No Due)
          </span>
        )}
        <Box className='flex flex-wrap items-center justify-between mt-4'>
          <Box className='flex flex-wrap items-center justify-between flex-1 w-full md:w-auto'>
            <Box className='w-1/2 mb-4 md:w-1/4 md:mb-0'>
              <Box>
                <Typography className='block  text-[#8A92A6] mb-1'>
                  First Name
                </Typography>
                <Typography className='text-[#232D42] font-bold text-[15px]'>
                  {student.firstName}
                </Typography>
              </Box>
            </Box>
            <Box className='w-1/2 mb-4 md:w-1/4 md:mb-0'>
              <Box>
                <Typography className='block  text-[#8A92A6] mb-1'>
                  Last Name
                </Typography>
                <Typography className='text-[#232D42] font-bold text-[15px]'>
                  {student.lastName}
                </Typography>
              </Box>
            </Box>
            <Box className='w-1/2 mb-4 md:w-1/4 md:mb-0'>
              <Box>
                {instituteType?.toLowerCase() == 'college' ? (
                  <>
                    <Typography className='block  text-[#8A92A6] mb-1'>
                      Branch Name
                    </Typography>
                    <Typography className='text-[#232D42] font-bold text-[15px]'>
                      {student.className}
                    </Typography>
                  </>
                ) : instituteType?.toLowerCase() == 'school' ? (
                  <>
                    <Typography className='block  text-[#8A92A6] mb-1'>
                      Class Name
                    </Typography>
                    <Typography className='text-[#232D42] font-bold text-[15px]'>
                      {student.departmentName}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography className='block  text-[#8A92A6] mb-1'>
                      Department Name
                    </Typography>
                    <Typography className='text-[#232D42] font-bold text-[15px]'>
                      {student.departmentName}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
            <Box className='w-1/2 mb-4 md:w-1/4 md:mb-0'>
              <Box>
                <Typography className='block  text-[#8A92A6] mb-1'>
                  Total Fee
                </Typography>
                <Typography className='text-[#232D42] font-bold text-[15px]'>
                  ₹{student.totalFees}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box className='flex justify-start w-full mt-2 md:w-auto md:mt-0 md:justify-end'>
            <Button
              className={
                `   ` +
                (writeOffRemaining ||
                balance <= 0 ||
                student?.status === 'DROPPED_OUT' ||
                student?.status === 'PASSED_OUT' ||
                student?.status === 'DELETED'
                  ? ' cursor-not-allowed'
                  : '')
              }
              disabled={
                writeOffRemaining ||
                balance <= 0 ||
                student?.status === 'DROPPED_OUT' ||
                student?.status === 'PASSED_OUT' ||
                student?.status === 'DELETED'
              }
              onClick={onAddClick}
              variant='contained'
            >
              Add Fee Details
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StudentInfoCard;
const Status = ({ status = '' }) => {
  if (status === 'ACTIVE')
    return <Chip className='h-6' label='Active' color='success' />;
  else if (status === 'INACTIVE')
    return <Chip label='InActive' color='warning' />;
  else if (status === 'DELETED') return <Chip label='Deleted' color='error' />;
  else if (status === 'DROPPED_OUT')
    return <Chip label='Dropped Out' color='error' />;
  else if (status === 'PASSED_OUT')
    return <Chip label='Passed Out' color='primary' />;
  else return <Chip label='NoStatus' />;
};
